import { AlpineComponent } from 'alpinejs';

const EventStage = ({ startDate }: { startDate: number }): AlpineComponent => ({
  backgroundHeight: '80vh',
  isMobile: false,
  daysUntilEvent: 0,
  startDate,
  init() {
    this.updateBackgroundHeight();
    window.addEventListener('resize', () => this.updateBackgroundHeight());

    this.updateDaysUntilEvent();

    this.$root.addEventListener('mousemove', (e: MouseEvent) => {
      const gradients = this.$root.querySelectorAll('.event-stage__gradient');

      gradients.forEach((item: HTMLDivElement) => {
        const position = Number(item.getAttribute('value'));
        const x = (window.innerWidth + e.pageX * position) / 90;
        const y = (window.innerHeight + e.pageY * position) / 90;

        item.style.transform = `translateX(${x}px) translateY(${y}px)`;
      });
    });
  },
  updateBackgroundHeight() {
    this.isMobile = window.matchMedia('(max-width: 960px)').matches;
    const height = this.isMobile
      ? this.$refs.content.offsetHeight + 200
      : window.innerHeight * 0.95;

    this.backgroundHeight = `${Math.round(height)}px`;
  },
  updateDaysUntilEvent() {
    const timeDifference = new Date(this.startDate).getTime() - Date.now();
    this.daysUntilEvent = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  }
});

export default EventStage;
